import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAssetRepo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="url(#Asset_Repo_svg__a)"
      fillOpacity={0.5}
      d="M3.44 13.375V6.642c0-.532.431-.963.963-.963h11.29c.532 0 .963.431.963.963v6.733a1.19 1.19 0 0 1-1.19 1.19H4.63a1.19 1.19 0 0 1-1.19-1.19"
      opacity={0.9}
    />
    <path
      fill="url(#Asset_Repo_svg__b)"
      fillOpacity={0.5}
      d="M3.44 7.407V6.87c0-.658.533-1.19 1.19-1.19h10.835a1.19 1.19 0 0 1 1.191 1.19v.537z"
    />
    <path
      fill="url(#Asset_Repo_svg__c)"
      fillOpacity={0.5}
      d="M7.364 9.438c0-.242.21-.438.47-.438h6.059c.259 0 .469.196.469.438s-.21.438-.47.438H7.835c-.26 0-.47-.196-.47-.438Z"
    />
    <path
      fill="url(#Asset_Repo_svg__d)"
      fillOpacity={0.5}
      d="M5.8 9.438c0-.242.21-.438.47-.438.259 0 .469.196.469.438s-.21.438-.47.438c-.259 0-.469-.196-.469-.438"
    />
    <path
      fill="url(#Asset_Repo_svg__e)"
      fillOpacity={0.5}
      d="M12 11.562c0-.242.211-.438.47-.438.26 0 .47.196.47.438s-.21.438-.47.438c-.259 0-.47-.196-.47-.438"
    />
    <path
      fill="url(#Asset_Repo_svg__f)"
      fillOpacity={0.5}
      d="M7.364 11.562c0-.242.21-.438.47-.438h3.058c.259 0 .469.196.469.438s-.21.438-.47.438H7.835c-.26 0-.47-.196-.47-.438Z"
    />
    <defs>
      <linearGradient
        id="Asset_Repo_svg__a"
        x1={14.178}
        x2={-2.334}
        y1={12.205}
        y2={11.693}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Repo_svg__b"
        x1={14.178}
        x2={-1.94}
        y1={6.948}
        y2={4.381}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale06)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale02)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Repo_svg__c"
        x1={21}
        x2={6.041}
        y1={11.5}
        y2={10.72}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale02)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale06)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Repo_svg__d"
        x1={21}
        x2={6.041}
        y1={11.5}
        y2={10.72}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale02)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale06)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Repo_svg__e"
        x1={21}
        x2={6.041}
        y1={11.5}
        y2={10.72}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale02)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale06)"
        />
      </linearGradient>
      <linearGradient
        id="Asset_Repo_svg__f"
        x1={21}
        x2={6.041}
        y1={11.5}
        y2={10.72}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="var(--dataviz-color-sequential-blue-scale02)" />
        <stop
          offset={1}
          stopColor="var(--dataviz-color-sequential-blue-scale06)"
        />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgAssetRepo;
